import React, { useState } from 'react';
import { Box, IconButton, Modal } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import { getFullImageUrl } from '../utils/urlHelpers';

const ProductGallery = ({ images = [], productName = '' }) => {
  const [current, setCurrent] = useState(0);
  const [lightbox, setLightbox] = useState(false);

  if (!images.length) return null;

  const prev = () => setCurrent(i => (i === 0 ? images.length - 1 : i - 1));
  const next = () => setCurrent(i => (i === images.length - 1 ? 0 : i + 1));

  return (
    <Box>
      {/* Ana görsel */}
      <Box sx={{ position: 'relative', cursor: 'pointer', borderRadius: 2, overflow: 'hidden', bgcolor: '#f5f5f5' }}
        onClick={() => setLightbox(true)}>
        <img
          src={getFullImageUrl(images[current].imageUrl)}
          alt={productName}
          style={{ width: '100%', maxHeight: 420, objectFit: 'contain', display: 'block' }}
        />
        {images.length > 1 && (
          <>
            <IconButton onClick={e => { e.stopPropagation(); prev(); }}
              sx={{ position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)', bgcolor: 'rgba(255,255,255,0.8)' }}>
              <ArrowBackIosNewIcon />
            </IconButton>
            <IconButton onClick={e => { e.stopPropagation(); next(); }}
              sx={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', bgcolor: 'rgba(255,255,255,0.8)' }}>
              <ArrowForwardIosIcon />
            </IconButton>
          </>
        )}
      </Box>

      {/* Thumbnail şeridi */}
      {images.length > 1 && (
        <Box sx={{ display: 'flex', gap: 1, mt: 1, overflowX: 'auto', py: 0.5 }}>
          {images.map((img, i) => (
            <Box key={img.id || i} onClick={() => setCurrent(i)}
              sx={{
                flexShrink: 0, width: 72, height: 60, borderRadius: 1, overflow: 'hidden',
                border: i === current ? '2px solid #f08a0c' : '2px solid transparent',
                cursor: 'pointer', opacity: i === current ? 1 : 0.65,
                transition: 'opacity 0.2s, border-color 0.2s'
              }}>
              <img src={getFullImageUrl(img.imageUrl)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </Box>
          ))}
        </Box>
      )}

      {/* Lightbox */}
      <Modal open={lightbox} onClose={() => setLightbox(false)}>
        <Box sx={{
          position: 'absolute', inset: 0, bgcolor: 'rgba(0,0,0,0.92)',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <IconButton onClick={() => setLightbox(false)}
            sx={{ position: 'absolute', top: 16, right: 16, color: 'white' }}>
            <CloseIcon fontSize="large" />
          </IconButton>
          {images.length > 1 && (
            <IconButton onClick={prev} sx={{ color: 'white', mr: 2 }}><ArrowBackIosNewIcon fontSize="large" /></IconButton>
          )}
          <img src={getFullImageUrl(images[current].imageUrl)} alt={productName}
            style={{ maxWidth: '85vw', maxHeight: '85vh', objectFit: 'contain', borderRadius: 8 }} />
          {images.length > 1 && (
            <IconButton onClick={next} sx={{ color: 'white', ml: 2 }}><ArrowForwardIosIcon fontSize="large" /></IconButton>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default ProductGallery;
